"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var jumpingDots = (0, system_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    25% {\n      transform: translateY(2px);\n    }\n    75% {\n      transform: translateY(-2px);\n    }\n  "], ["\n    25% {\n      transform: translateY(2px);\n    }\n    75% {\n      transform: translateY(-2px);\n    }\n  "])));
var DotsLoader = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'primary' : _b, _c = _a.type, type = _c === void 0 ? 'dots' : _c;
    var theme = (0, material_1.useTheme)();
    var _d = theme.palette, primary = _d.primary, secondary = _d.secondary;
    var themeColor = color === 'blue'
        ? '#0060E0'
        : color === 'primary'
            ? primary.main
            : secondary.main;
    return (react_1.default.createElement(material_1.Box, { sx: {
            '> span': {
                width: 6,
                height: 6,
                margin: '0 2px',
                borderRadius: '50%',
                display: 'inline-block',
                backgroundColor: type === 'dots' ? themeColor : 'currentColor',
                animation: "".concat(jumpingDots, " 600ms infinite linear "),
                '&:nth-of-type(3n)': {
                    animationDelay: '-300ms',
                },
                '&:nth-of-type(2n)': {
                    animationDelay: '-150ms',
                },
            },
        } },
        react_1.default.createElement("span", null),
        react_1.default.createElement("span", null),
        react_1.default.createElement("span", null)));
};
exports.default = DotsLoader;
var templateObject_1;
//# sourceMappingURL=dotsLoader.js.map